module.exports = __webpack_public_path__ + "img/mischakim_no.af123b08.png";